export default {
    search_placeholder: "Buscar...",
    showing_results: "Mostrando {0} resultado",
    showing_results_plural: "Mostrando {0} resultados",
};
